import { bsrmAppServiceApi } from "../../../app/bsrm/bsrmAppServiceApi";
import { BASE_API_BSRM } from "../../../constants/apiUrl";
import {
  GetSupplierPaymentHistoryParams,
  GetSupplierPaymentHistoryResponseType,
} from "../../../types/bsrm/statements";

export const supplierPaymentHistoryApi = bsrmAppServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentHistory: builder.query<
      GetSupplierPaymentHistoryResponseType,
      GetSupplierPaymentHistoryParams
    >({
      query: (params) => ({
        url: BASE_API_BSRM.getPaymentHistory,
        params,
      }),
    }),
    // exportSupplierPaymentHistory: builder.query({
    //   query: (queryArgs) => ({
    //     url: BASE_API.exportSupplierPaymentHistory,
    //     ...queryArgs,
    //   }),
    // }),
  }),
});

export const {
  useGetPaymentHistoryQuery,
  // useExportSupplierPaymentHistoryQuery,
} = supplierPaymentHistoryApi;
